import React from 'react';
import OptionButton from '../shared/OptionButton';
import { WEEKDAYS } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RunClubDayStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {WEEKDAYS.map((day) => (
        <OptionButton
          key={day.value}
          label={day.label}
          value={day.value}
          selected={answer === day.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default RunClubDayStep;
